import api from '@/services/Api';
import Impfstoffe from '@/types/Impfstoffe';
import Charge from '@/types/Charge';
import Teilimpfungen from '@/types/Teilimpfungen';
import Impfschema from '@/types/Impfschema';
import ElgaImpfstoffe from '@/types/ElgaImpfstoffe';
import { ActionContext, Module } from 'vuex';
import Impfdosis from '@/types/Impfdosis';
import { AxiosResponse } from 'axios';
import { ImpfstoffState, RootState } from '@/store/types';
import ImmunizationTarget from '@/types/ImmunizationTarget';

export type ImpfstoffeSelect = {
    chargen?: boolean;
    elgaimpfstoffe?: boolean;
    immunziationTarget?: boolean;
    impfschemen?: boolean;
    teilimpfungen?: boolean;
    teilimpfungsarten?: boolean;
    impfdosen?: boolean;
    nachtrag?: boolean;
};

type Context = ActionContext<ImpfstoffState, RootState>;

export const impfstoff: Module<ImpfstoffState, RootState> = {
    namespaced: true,
    state: {
        impfstoffe: [],
        teilimpfungen: [],
        specialSituationIndication: [],
        impfschema: [],
        chargen: [],
        elgaimpfstoffe: [],
        elgadosis: [],
        impfdosen: [],
        immunizationtarget: [],
        selectedIS: null,
        selectedCharge: null,
        selectedImpfschema: null,
        loaders: {
            impfstoffe: false,
        },
    },
    actions: {
        loadImpfstoffchargen({ commit, rootState }: Context): void {
            api.post('lager/impfstoffchargen/load', { impfstelle_id: rootState.authentication.impfstelle_id })
                .then((response) => commit('setImpfchargen', response.data.body))
                .catch(console.error);
        },
        loadImpfstoffe({ commit, rootState }: Context, payload: ImpfstoffeSelect): void {
            commit('setLoadersImpfstoffe', true);

            const data = {
                impfstelle_id: rootState.authentication.impfstelle_id,
                ...payload,
            };

            api.post('verwaltung/impfstoffe/load', data)
                .then(({ data: { body, selections } }: AxiosResponse) => {
                    commit('setImpfstoffe', body);

                    if (payload?.chargen) {
                        commit('setImpfchargen', selections.chargen);
                    }
                    if (payload?.elgaimpfstoffe) {
                        commit('setElgaimpfstoffe', selections.elgaimpfstoffe);
                    }
                    if (payload?.immunziationTarget) {
                        commit('setImmunizationtarget', selections.immunziationTarget);
                    }
                    if (payload?.impfschemen) {
                        commit('setImpfschema', selections.impfschemen);
                    }
                    if (payload?.teilimpfungen) {
                        commit('setTeilimpfungen', selections.teilimpfungen);
                    }
                    if (payload?.teilimpfungsarten) {
                        commit('setTeilimpfungsarten', selections.teilimpfungsarten);
                    }
                    if (payload?.impfdosen) {
                        commit('setImpfdosen', selections.impfdosen);
                    }
                })
                .catch(console.error)
                .finally(() => commit('setLoadersImpfstoffe', false));
        },
    },
    mutations: {
        setImmunizationtarget(state: ImpfstoffState, immunizationtarget: Partial<ImmunizationTarget>[]): void {
            state.immunizationtarget = immunizationtarget.map((data) => new ImmunizationTarget(data));
        },
        setImpfstoffe(state: ImpfstoffState, impfstoffe: Partial<Impfstoffe>[]): void {
            state.impfstoffe = impfstoffe.map((data) => new Impfstoffe(data));
        },
        setImpfchargen(state: ImpfstoffState, chargen: Partial<Charge>[]): void {
            state.chargen = chargen.map((data) => new Charge(data));
        },
        setTeilimpfungen(state: ImpfstoffState, teilimpfungen: Partial<Teilimpfungen>[]): void {
            state.teilimpfungen = teilimpfungen.map((data) => new Teilimpfungen(data.teilimpfungsnr, data));
        },
        setImpfschema(state: ImpfstoffState, impfschema: Partial<Impfschema>[]): void {
            state.impfschema = impfschema.map((data) => new Impfschema(data));
        },
        setElgaimpfstoffe(state: ImpfstoffState, impfstoffe: Partial<ElgaImpfstoffe>[]): void {
            state.elgaimpfstoffe = impfstoffe.map((data) => new ElgaImpfstoffe(data));
        },
        setImpfdosen(state: ImpfstoffState, impfdosen: Partial<Impfdosis>[]): void {
            state.impfdosen = impfdosen.map((data) => new Impfdosis(data));
        },
        setLoadersImpfstoffe(state: ImpfstoffState, loading: boolean): void {
            state.loaders.impfstoffe = loading;
        },
    },
};
